import { ref, type Ref } from 'vue'
import { useGlobalStore } from '@/stores/global'

export interface HCaptchaResult {
  token: string | null
  error: boolean
}

export function useHCaptcha() {
  const store = useGlobalStore()
  const hCaptchaRef: Ref<{
    executeAsync: () => Promise<{ response: string }>
  } | null> = ref(null)

  async function execute(): Promise<HCaptchaResult> {
    try {
      const { response: token } = await hCaptchaRef.value!.executeAsync()
      return { token, error: false }
    } catch {
      return { token: null, error: true }
    }
  }

  return {
    hCaptchaRef,
    siteKey: store.hcaptcha_key,
    execute,
  }
}
